import * as React from 'react';

interface IProps {
    className?: string;
}

export const BaseLandholdScreen: React.FC<IProps> = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 149 113"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <polygon
                id="path-1"
                points="0 0.342 148.174 0.342 148.174 113 0 113"
            />
        </defs>
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="01-intro-copy"
                transform="translate(-645.000000, -456.000000)"
            >
                <g id="Group-10" transform="translate(645.000000, 455.000000)">
                    <g id="Group-3" transform="translate(0.000000, 0.658000)">
                        <mask id="mask-2" fill="white">
                            <use xlinkHref="#path-1" />
                        </mask>
                        <g id="Clip-2" />
                        <path
                            d="M138.7001,81.5674 C136.1101,83.0274 130.1401,82.0074 126.9611,82.1774 C122.2611,82.4184 117.5601,82.6684 112.8711,82.9084 C79.2911,84.6584 45.7101,86.3974 12.1401,88.1374 C9.5111,62.0074 7.9501,35.8174 7.4401,9.5574 C50.5001,10.5574 93.5601,9.9784 136.5811,7.8274 C138.2111,24.2674 139.4711,40.7374 140.2001,57.2484 C140.4101,62.0974 140.5601,66.9484 140.7211,71.8074 C140.7611,73.4274 140.8011,75.0384 140.8411,76.6584 C142.6101,80.5574 141.9001,82.1874 138.7001,81.5674 M147.9801,69.3874 C147.3311,47.5474 145.7911,25.7574 143.5511,4.0174 C143.3501,2.1174 142.0201,0.2274 139.8811,0.3474 C95.3101,2.6574 50.7001,3.2774 6.0911,2.2074 C5.3811,2.1884 4.7901,2.3584 4.3011,2.6174 C2.2611,2.2874 -0.0399,3.4474 0.0001,6.1084 C0.4501,34.8174 2.1711,63.4374 5.1501,91.9984 C5.3501,93.8974 6.6711,95.7884 8.8211,95.6684 L71.8411,92.3974 C71.8301,92.5074 71.8101,92.6074 71.8101,92.7174 L71.8101,103.6474 C71.8101,104.2574 71.9301,104.7884 72.1501,105.2374 C67.8811,105.3684 63.6201,105.5074 59.3501,105.6474 C54.6311,105.7974 54.6111,113.1474 59.3501,112.9984 L92.2401,111.9374 C96.9611,111.7884 96.9801,104.4374 92.2401,104.5884 C87.7911,104.7274 83.3501,104.8784 78.9001,105.0174 C79.0601,104.6184 79.1601,104.1684 79.1601,103.6474 L79.1601,92.7174 C79.1601,92.4674 79.1311,92.2374 79.0911,92.0174 C97.4001,91.0674 115.7111,90.1184 134.0201,89.1684 C149.3201,88.3574 148.4401,84.8574 147.9801,69.3874"
                            id="Fill-1"
                            fill="#000000"
                            mask="url(#mask-2)"
                        />
                    </g>
                    <path
                        d="M71.2104,38.2556 C73.2104,30.7156 67.6404,27.3356 60.8904,26.2256 C54.6804,25.2056 46.2604,26.5456 45.1204,33.9456 C44.6404,37.0956 49.4604,38.4456 49.9504,35.2756 C50.7304,30.2356 57.2804,30.4856 61.1204,31.3356 C65.7504,32.3656 67.6704,34.5756 65.5704,39.0756 C63.0804,44.4056 50.8804,52.1256 47.7604,43.1056 C46.7204,40.0856 41.8804,41.3856 42.9404,44.4356 C48.0904,59.3566 68.1904,49.6356 71.2104,38.2556"
                        id="Fill-4"
                        fill="#000000"
                    />
                    <path
                        d="M95.2802,25.6258 C92.5512,24.6358 88.9902,23.5858 86.1402,24.4858 C82.6312,25.5958 81.1102,29.5358 79.8902,32.6858 C77.4502,38.9958 78.4502,48.5458 86.4302,49.9458 C89.5912,50.4958 90.9402,45.6758 87.7702,45.1258 C81.8712,44.0958 83.2402,35.8458 85.5912,32.1758 C87.4002,29.3558 88.5302,28.9258 91.7202,29.7558 C93.1602,30.1258 94.5702,30.6058 95.8812,31.3358 C98.7302,32.9258 100.1102,35.3258 100.3102,38.5558 C100.5012,41.6358 100.7202,46.5058 97.1102,47.4958 C94.0102,48.3458 95.3312,53.1758 98.4402,52.3158 C104.8102,50.5658 105.7002,43.8358 105.2912,38.0458 C104.8502,31.8458 100.9802,27.6958 95.2802,25.6258"
                        id="Fill-6"
                        fill="#000000"
                    />
                    <path
                        d="M74.7104,66.2156 C74.3004,69.0156 70.6604,68.8356 68.5204,68.4056 C67.0604,68.1156 65.0504,67.7366 64.8804,65.8456 C64.8204,65.1556 65.2704,64.1156 65.5104,63.4756 C66.1204,61.8656 67.0704,60.4156 68.6904,59.7056 C70.1904,59.0456 73.3504,58.7256 73.8204,60.7556 C74.3404,62.9756 77.7604,62.0356 77.2404,59.8166 C76.3714,56.1056 72.1404,55.1756 68.7804,55.9556 C64.9104,56.8556 62.6404,60.2056 61.7004,63.8656 C61.2604,65.5756 61.0004,67.5156 62.1104,69.0356 C63.3504,70.7456 66.0304,71.5456 68.0004,71.8966 C71.8604,72.5856 77.4404,71.9056 78.1304,67.1556 C78.4504,64.9256 75.0304,63.9656 74.7104,66.2156"
                        id="Fill-8"
                        fill="#000000"
                    />
                </g>
            </g>
        </g>
    </svg>
);
